<template>
  <!--签署方表单-->
  <div class="singer-form">
    <el-form :model="signatory" :rules="rules" ref="signatoryTip" size="small">

			<el-form-item prop="emailOrPhone">
				<el-input @blur="handlerTargetIdBlur(signatory.emailOrPhone)" v-model="signatory.emailOrPhone"
									placeholder="签署方接收手机/邮箱"/>
			</el-form-item>
      <!--企业的时候才有手动输入，个人的时候是个人的修改方式-->
      <template v-if="signatory.canSelectArray && (+signatory.signatoryUserType === 1 && signatory.canSelectArray.length > 0 && !signatory.ManualInput || +signatory.signatoryUserType === 0 && signatory.canSelectArray.length > 1)">
				<el-form-item>
					<el-select @change="handleSelectCorpAccount($event, signatory)" v-model="signatory.canSelectArrayIndex"
											size="small" class="select">
						<el-option :value="vi" :label="v.name" v-for="(v, vi) in signatory.canSelectArray" :key="vi"/>

            <!--手动输入，选择此项显示输入框，手动输入-->
            <el-option v-if="signatory.signatoryUserType === 1" value="ManualInput" label="手动输入"/>
					</el-select>
				</el-form-item>
			</template>
			<template v-else>
				<!-- 文本框 -->
				<el-form-item :prop="signatory.disabled !== 'disabled' ? 'signatoryFullName' : ''" :show-message="signatory.disabled !== 'disabled'">
          <!-- 旧版 -->
                    <!-- 新版：追加新功能，需要在签章中显示签署方名称，这里需要改造 -->
                    <el-input :value="signatory.signatoryFullName" @input="(val)=>{signatory.signatoryFullName=val;this.$emit('qsNameChange', signatory)}" :disabled="signatory.disabled === 'disabled'"
                    					placeholder="请输入签署方名称"/>
				</el-form-item>
			</template>

      <el-form-item>
        <el-select @change="handleSignUserType(signatory)" v-model="signatory.signatoryUserType" :disabled="signatory.disabled === 'disabled'" size="small" class="select">
          <el-option :value="0" label="个人用户"/>
          <el-option :value="1" label="企业用户"/>
        </el-select>
      </el-form-item>
			<!-- 身份证 和 营业执照号 -->
			<template v-if="signatory.signatoryUserType === 0">
				<!-- 身份证 -->
				<el-form-item v-if="signatory.signatoryUserType === 0" :prop="signatory.disabled !== 'disabled' ? 'IDCard' : ''"
											:show-message="signatory.disabled !== 'disabled'" style="position: relative;">
					<el-input v-model="signatory.IDCard" :disabled="signatory.disabled === 'disabled'"
										placeholder="请输入中国大陆18位身份证号码"/>
					<a @click="amendSign(signatory)" v-if="signatory.ischange === 1" href="javascript:void (0)"
							class="color-success amend-signator amend-tab__form">修改</a>
				</el-form-item>

				<!-- 营业执照号 -->
				<el-form-item v-else-if="signatory.signatoryUserType !== 1" :prop="(signatory.disabled === 'disabled') || signatory.signatoryUserType === 1 ? '' : 'BusinessLicenseNo'"
											:show-message="signatory.disabled !== 'disabled'" style="position: relative;">
					<el-input v-model="signatory.BusinessLicenseNo" :disabled="(signatory.disabled === 'disabled') || signatory.signatoryUserType === 1"
										placeholder="请输入营业执照号"/>
					<a @click="amendSign(signatory)" v-if="signatory.ischange === 1" href="javascript:void (0)"
							class="color-success amend-signator amend-tab__form">修改</a>
				</el-form-item>
			</template>
      <el-form-item>
        <el-checkbox v-model="signatory.authLevel" :true-label="11" :false-label="null">
          需要人脸识别
      </el-checkbox>
      </el-form-item>

			<!-- 按要求添加完成按钮(关闭) -->
			<el-form-item>
        <el-button style="width:100%" type="danger" size="small" @click="closeToolTip">保存</el-button>
      </el-form-item>
    </el-form>
    <p class="tels"><i @click="telClick($event)" class="icon icon-btn_tels"></i></p>
  </div>
</template>

<script>
  import {mobileOrEmail, identityNo} from '../../assets/js/lib/valid-methods'

  export default {
    data () {
      return {
        rules: {
          signatoryMobile: [{validator: mobileOrEmail, trigger: 'blur'}],
          childUserName: [{validator: mobileOrEmail, trigger: 'blur'}],
          signatoryFullName: [{required: true, message: '请输入签署方名称', trigger: 'blur'}],
          signatoryIdentityCard: [{validator: identityNo, trigger: 'blur'}]
        }
      }
    },
    props: {
      signatory: {
        type: Object
			},
			// index
			index: {
				type: Number
			}
    },
    watch: {
      signatory: {
        handler(val) {
          this.$emit('update:signatory', val)
        },
        deep: true
      }
    },
    mounted() { },
    methods: {
      amendSign(sign) {
        this.$emit('amendSign', sign)
      },
      // 联系方式的blur事件
      handlerTargetIdBlur(emailOrPhone) {
        this.$emit('targetBlur', emailOrPhone, this.index)
      },
      // 点击通讯薄
      telClick: function () {
        this.$emit('telsClick', this.signatory, this.index)
			},
			// 下拉框选择
			handleSelectCorpAccount(event, signatory) {
				this.$emit('handleSelectCorpAccount', event, signatory)
			},
      // 处理用户类型选择
      handleSignUserType (signator) {
        if (signator.signatoryUserType === 0) {
          signator.handSign = 0
          signator.signatoryMobile = signator.childUserName
          signator.childUserName = ''
        } else {
          signator.handSign = 1
          signator.childUserName = signator.signatoryMobile
          signator.signatoryMobile = ''
        }
			},
			// 完成事件
			closeToolTip() {
        this.$emit('closeToolTip', this.signatory, this.index)
			},
			// 清空表单验证
			clearValidate() {
				if (this.$refs['signatoryTip']) {
					this.$refs['signatoryTip'].clearValidate()
				}
			}
    },
    name: "singer-form"
  }
</script>

<style lang="less" scoped>
  .singer-form {
    width: 260px;
    box-sizing: border-box;
    position: relative;
    padding: 20px 36px 20px 20px;

    .amend-signator {
      position: absolute;
      width: 30px;
      right: -35px;
    }

    .select {
      width: 100%;
    }

    .tels {
      position: absolute;
      top: 25px;
      right: 10px;
      cursor: pointer;

      .icon {
        width: 20px;
        height: 20px;
        background-size: contain;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/singer-form/index.vue